import React from 'react';
import './home.css'

function Home() {
  return (
    <div className="home">
      <h1>DISTRIBUIDORA DE ÁGUA E GÁS MINERALLI</h1>
      <h4>Telefone: (19) 3546-1563 - Cordeirópolis/SP</h4>
      <h5>email: administrativo@distribuidoramineralli.com.br</h5>

      <h3>Nosso site está em desenvolvimento!</h3>  
    </div>
  );
}

export default Home;